export default __webpack_public_path__ + "static/media/Emprego-EN.2c67fbf0.png";